export default __webpack_public_path__ + "static/media/goldAward.2a0825ee.svg";